import { Box, styled } from '@mui/material'

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2.5),
  flexWrap: 'wrap',
  justifyContent: 'center',
  listStyle: 'none',
}))
